import { PaymentsTransaction } from '@mindfulchefuk/api-client'

import errorHandler from '@mindfulchefuk/utils/errorHandler'

interface PaymentTransactionParams {
  prefixId: string
  orderId: string
}

export type PaymentTransationStatus = 'completed' | 'failed' | 'pending'

interface PaymentTransactionResponse {
  amount: number
  cardPayment: number
  status: PaymentTransationStatus
  errorMessage: string
}

export const getPaymentTransaction = async ({
  prefixId,
  orderId,
}: PaymentTransactionParams): Promise<PaymentTransactionResponse> => {
  try {
    const { data: paymentTransaction } = await PaymentsTransaction.where({
      purchase_id: `${prefixId}${orderId}`,
    })
      .order({ id: 'desc' })
      .extraParams({
        pagination_links: 'false',
      })
      .first()

    if (!paymentTransaction) return undefined

    const {
      amount,
      card_payment: cardPayment,
      status,
      error_message: errorMessage,
    } = paymentTransaction

    return {
      amount: parseFloat(amount),
      cardPayment: parseFloat(cardPayment),
      status,
      errorMessage,
    }
  } catch (error) {
    throw errorHandler(error)
  }
}
